








































































import { Component, Prop, Vue, Inject, Ref } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { Search } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';
import { Listitem } from '@/data/models/listitem.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
	},
})
export default class EditListItem extends Vue {
	@Prop() listitem?: Listitem;
	@Inject('CrudService') listitemCrudService!: CrudService<Listitem>;
	@Ref('modalBody') modalBody!: Element;

	newListitem: Listitem;

	constructor() {
		super();
		this.newListitem = new Listitem();
	}

	loadListitem(id: number) {
		const search = new Search('selistitem');
		search.addSimpleFilter('id', id);
		this.listitemCrudService
			.searchEntities(Listitem, 'selistitem', search, new Page(1))
			.then((results) => {
				this.newListitem = results[0];
			});
	}

	submit() {
		this.$emit('submit', this.newListitem);
	}

	beforeMount() {
		if (this.listitem) {
			if (this.listitem.id) {
				this.loadListitem(this.listitem.id);
			} else {
				this.listitem = new Listitem();
			}
		}
	}
}
